import { Button } from 'react-md';
import { Grid,Cell,Card, CardTitle, CardText,NavigationDrawer,CardActions} from 'react-md';
import MathJax from '../../components/react-mathjax-preview';
import 'react-dynamic-swiper/lib/styles.css'
import React, { Component } from 'react';
import { convertFromRaw,  EditorState } from 'draft-js';
import BarChart from '../../components/BarChartCustom'
import TextEditor from '../../components/TextEditor'

const getLabel = (tooltipItem, data) => {
    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
    if (label) {
        label += ': ';
    }
    label += Math.round(tooltipItem.yLabel * 100) / 100;
  
    return label+"% of Students Picked This Answer";
  }


export default class LiveAnalytics extends Component {
    
    
       constructor(props){
        super(props)
      
        this.state={
            graphData : null,
            graphLabel : null
        }
        
    }

    UNSAFE_componentWillMount(){
        console.log("liveAnalytics ",this.props.liveAnalytics.answers_count)
        console.log("currentque ",this.props.currentQuestion.answers)
        var userCount = this.props.liveAnalytics.user_count
        var maxAns = this.props.currentQuestion.answers.length
        var liveData = this.props.liveAnalytics.answers_count
        var randomizedLiveData = []
        var alphabet = ["A","B","C","D","E","F","G","H","I","J","K"]
        var tempGraphData = []
        var tempGraphLabel = []
        var tempAnswerArr =[]
        var maxLength =this.props.liveAnalytics.answers_count.length
        var content = []
       for(var i = 0 ; i <= maxAns-1 ; i++){
            var cont = this.props.currentQuestion.answers[i].answer_text.toString('html',null).replace("<p><br></p>", "").replace("<p><br></p>", "")
            content[i]  = React.createElement(MathJax,{"math":cont});
            console.debug("textxx ", content[i]  )
        }
        
        
        for(var j = 0 ; j <= maxAns-1 ; j++){
            tempAnswerArr[j] = this.props.currentQuestion.answers[j].answer_id
            for(var i = 0 ; i <= maxLength-1 ; i++){
                if(tempAnswerArr[j] == liveData[i].answer_id){
                    console.debug(tempAnswerArr[j],"equal",liveData[i].answer_id)
                    randomizedLiveData[j]=liveData[i]
                    console.debug("randomizedLiveData  ",randomizedLiveData)
                    break
                }else{
                    console.debug("value not present ",tempAnswerArr[j])
                    randomizedLiveData[j]=0
                }
            }
        }
        console.debug("randomizedLiveData",randomizedLiveData)
        for(var i = 0 ; i <= randomizedLiveData.length-1 ; i++)
        {
            if(randomizedLiveData !== 0){
                tempGraphData[i] = (randomizedLiveData[i].answer_count/userCount)*100
                tempGraphLabel[i] = alphabet[i]
            }else{
                tempGraphData[i] = 0
                tempGraphLabel[i] = alphabet[i]
            }
        }
        console.debug(tempGraphData,"    ",tempGraphLabel)
        this.setState({
            graphData : tempGraphData,
            graphLabel : tempGraphLabel,
            currentQue : this.props.currentQuestion.answers,
            content :content
        });
    }
    convertToHTML(text){
        let retVal = "";
        try{
          retVal = TextEditor.getHTMLStringFromEditorState(
            EditorState.createWithContent(convertFromRaw(JSON.parse(text) ))).toString('html',null);
        }
        catch(err){
          console.error(err.message);
        }
        return retVal;
      }
    render() {
        let floatFooter = {
          position: 'fixed',
          bottom: '0px',
          width: '100%',
          backgroundColor: 'white',
          float: 'left',
          zIndex: '1',
        };
      
    
      return (
        
        <Grid id = "liveanalytics"
        visible={this.props.visibility}>
        <Cell size={7} >
       {/* <DialogContainer
            id = "liveanalytics"
            visible={this.props.visibility}
            focusOnMount={false}>
        */}
        <Card class="border-dark mb-3"
         style = {{ width : '320px',height:"90%",overflow:'auto',position:'fixed',
        bottom:'59px',right: '9px'}}><br/>    
               <CardTitle style={{backgroundColor:"white",width:"100%"}}>
                  <h1 style={{paddingLeft: "83px"}}>Result</h1>
                </CardTitle>
                <div>
                    
                        <BarChart
                        showxAxesLabel={true} 
                        stepSize={1}
                        getBarLabel={getLabel}
                        graphTitleClass="graphTitleStyle"  
                        //title="LiveAnalytics" 
                        data={this.state.graphData}  
                        label={this.state.graphLabel}   
                        />  
                </div> <br/><br/>
                <h3 style={{paddingLeft:"10px",textDecoration: "underline"}}>Labels:</h3>     
                <CardText>
                    {
                        this.state.currentQue !== null && this.state.currentQue !== undefined ?
                            
                            this.state.currentQue.map((exp,i) =>
                               <div>
                                <table style={{borderBottom: "1px solid #ddd"}}>
                                <tr >
                                    <td style={{width: "40px"}}>{this.state.graphLabel[i]} :</td>
                                    <td >{this.state.content[i]}</td>
                                    <br/>
                                </tr>
                                </table>
                                <br/></div>
                            )
                            :""
                            
                    }<br/><br/>
                    {this.state.texttemp}
                </CardText>    
                
              {/* <div style = {floatFooter}>

              <center>

                    <Button flat secondary style={{ backgroundColor:'#ff4081'}}
                      swapTheming onClick={this.props.closeClick}>
                      Close
                    </Button><br/>

              </center>
              </div>*/}
              <CardActions centered>
                 <Button flat secondary style={{ position: 'fixed', bottom: '65px', backgroundColor:'red'}} 
                  swapTheming onClick={this.props.closeClick}>
                      Close
                 </Button>
                </CardActions>
              </Card>
        {/*</DialogContainer>*/}
        </Cell>
                </Grid>
        
      )
    }
}